/* eslint-disable */
import moment from "moment";
import axios from "axios";
import store from "../../store/index";

export default {
  name: "ApprovalStatusPopUp",
  props: {
    fileName: {
      type: String,
      default: "",
    },
    docId: {
      type: String,
      default: "",
    },
    version: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      getbyId: "",
      idtoken: "",
      collapseId: "",
      showCollapse: [false],
      baseurl: process.env.VUE_APP_Service_URL,
      baseapi: process.env.VUE_APP_Service_URL,
    };
  },
  components: {},

  async mounted() {
    this.getApprovalStatus();
  },
  methods: {
    close() {
      this.$emit("closemodal");
    },
    showCollapseFunc(index) {
      this.showCollapse[index] = !this.showCollapse[index];
    },
    async getApprovalStatus() {
      this.idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/etmf/document/approvalstatus?documentId=${this.docId}&version=${this.version}`,
          {
            headers: {
              Authorization: "Bearer " + this.idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.getbyId = res.data;
          console.log("getBYId", this.getbyId);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};